import { render, staticRenderFns } from "./teacherSidebar.vue?vue&type=template&id=03f81ca8&scoped=true"
import script from "./teacherSidebar.vue?vue&type=script&lang=js"
export * from "./teacherSidebar.vue?vue&type=script&lang=js"
import style0 from "./teacherSidebar.vue?vue&type=style&index=0&id=03f81ca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f81ca8",
  null
  
)

export default component.exports